import { useEffect, useRef, useState } from "react";

import large from "./assets/large.png";
import large1 from "./assets/large1.png";
import large2 from "./assets/large3.png";

import cardImg1 from "./assets/one.png";
import cardImg2 from "./assets/two.png";
import cardImg3 from "./assets/three.png";

const solutions = [
  {
    id: "rosters",
    label: "Rosters Effectiveness",
    tabImage: large,
    image: cardImg1,
    title: "Rosters Effectiveness",
    desc1:
      "Roster management provides a spreadsheet-style interface, allowing seamless shift adjustments through simple click-and-drag actions, improving workforce organization, flexibility, and scheduling efficiency across teams.",
    desc2:
      "Users can easily plan, modify, and manage employee schedules using intuitive drag-and-drop features, ensuring accuracy, saving time, and enhancing productivity in daily roster management.",
  },
  {
    id: "workload",
    label: "Optimized Workload Planning",
    tabImage: large1,
    image: cardImg2,
    title: "Optimized Workload Planning",
    desc1:
      "Specializes in smart warehouse management using RFID, barcode, and QR scanners integrated with advanced inventory software to streamline operations, enhance accuracy, and boost overall productivity.",
    desc2:
      "Streamlines warehouse operations through advanced inventory software, enabling real-time tracking, seamless control, optimized resource management, reduced errors, and significantly improved overall accuracy and productivity across processes.",
  },
  {
    id: "allocation",
    label: "Automatic Allocation",
    tabImage: large2,
    image: cardImg3,
    title: "Automatic Allocation",
    desc1:
      "Work allocation is automated with customizable rules, enabling efficient task distribution across diverse scenarios while improving accuracy, productivity, and workforce utilization seamlessly.",
    desc2:
      "Automated allocation intelligently applies multiple rules to match different operational needs, ensuring flexible workflows, optimized performance, and consistent task management across all work scenarios.",
  },
];

const HomeKeySolutions = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isPausedRef = useRef(false);
  const indexRef = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    indexRef.current = activeIndex;
  }, [activeIndex]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (isPausedRef.current) return;

      const next = (indexRef.current + 1) % solutions.length;
      indexRef.current = next;
      setActiveIndex(next);
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <section className="w-full bg-white font-epilogue py-16 px-5">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-10 max-w-[1400px] mx-auto w-[90%]">
        <div className="flex-1 w-full lg:min-w-[300px] lg:-translate-y-[60px] flex flex-col items-center lg:items-start text-center lg:text-left">
          <h1 className="text-black font-bold text-[clamp(22px,3vw,36px)]">
            Key Solutions
          </h1>

          <div className="border-l-2 border-[#E5E7EB] pl-4 mt-10 w-full max-w-[600px]">
            {solutions.map((item, index) => (
              <div key={item.id} className="flex items-start gap-4 mb-5">
                <span className="text-[#004BA8] text-[20px]">-</span>

                <p
                  className={`w-full text-left text-[16px] px-4 py-2 rounded-full cursor-pointer transition-all duration-300 ${
                    activeIndex === index
                      ? "bg-[#004BA8] text-white"
                      : "text-[#616161]"
                  }`}
                  onMouseEnter={() => {
                    isPausedRef.current = true;
                    setActiveIndex(index);
                  }}
                  onMouseLeave={() => {
                    isPausedRef.current = false;
                  }}
                >
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-[30px] shadow-xl border border-black overflow-hidden w-full md:w-[90%] min-h-[350px] flex">
          <div className="flex flex-col md:flex-row items-center gap-6 p-6 flex-1">
            <img
              src={solutions[activeIndex].image}
              alt={solutions[activeIndex].title}
              className="w-full md:w-[260px] h-[260px] object-cover rounded-xl"
            />

            <div className="flex-1 text-center md:text-left">
              <h2 className="text-[20px] font-bold mb-2">
                {solutions[activeIndex].title}
              </h2>
              <p className="text-[#444] text-[14px] mb-2">
                {solutions[activeIndex].desc1}
              </p>
              <p className="text-[#444] text-[14px]">
                {solutions[activeIndex].desc2}
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HomeKeySolutions;
